<template>
    <template-item
        v-slot="{ object, rules }"
        :model="$productBlankGroup"
        :show-actions="$auth.hasRight('products__edit_information')"
        object-key-for-title="name"
    >
        <v-col>
            <v-text-field
                v-model="object.name"
                class="mb-3"
                dense
                hide-details
                label="Наименование"
                outlined
            />
        </v-col>
    </template-item>
</template>

<script>

export default {
    name: "ProductBlankGroupItem",


    data: () => {
        return {};
    },

    computed: {},

    methods: {},

    created() {
    },
};
</script>
